import React, { useContext } from 'react';
import { SelectField as BaseSelectField } from '@ubeya/shared-web/components';
import useAddNewSelector from '@ubeya/shared-web/hooks/useAddNewSelector';
import useTags from '@ubeya/shared/hooks/account/useTags';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { required } from '@ubeya/shared/utils/form';
import styled from 'styled-components';
import { DELAWARE_NORTH_EVENT_DAY_TAG_ID } from '@ubeya/shared/utils/accounts';
import TagsModal from 'settings/components/AccountSettings/Tags/TagsModal';

const SelectField = styled(BaseSelectField)`
  .label {
    display: flex;
    gap: 5px;
    color: ${({ theme, $showWarning }) => $showWarning && theme.colors.redNegative};
  }
`;

const TagsSelectField = ({ title, tags, onAdd, isRequired = false, showWarning = false, onDNTagChange }) => {
  const { t } = useContext(ConfigContext);

  const { tagsOptions: defaultTagsOptions, addTag, colorsOptions, mappedColors } = useTags();
  const { isOpen: tagModal, setIsOpen: setTagModal, options: tagsOptions, onChange } = useAddNewSelector({
    options: defaultTagsOptions,
    addText: 'addNewTag',
    isMulti: true
  });

  const onChangeTag = (value, input) => {
    onChange(value, input);
    if (onDNTagChange && value && value.length && value.includes(DELAWARE_NORTH_EVENT_DAY_TAG_ID)) {
      onDNTagChange();
    }
  };

  return (
    <>
      <SelectField
        name="tags"
        title={title || t('tags')}
        options={tagsOptions}
        onChange={onChangeTag}
        usePortal
        creatable
        required={isRequired}
        validate={isRequired && required}
        $showWarning={showWarning}
      />

      {tagModal && (
        <TagsModal
          selectedTag={{ title: tagModal?.[tagModal?.length - 1] || '' }}
          colorsOptions={colorsOptions}
          mappedColors={mappedColors}
          totalTags={tagsOptions.length}
          onClose={() => setTagModal(false)}
          onConfirm={async (values) => {
            const { data } = await addTag(values);
            onAdd([...tags, data?.id]);
          }}
        />
      )}
    </>
  );
};

export default TagsSelectField;
